import React, { Component } from 'react';



class hua extends Component {
    // state = {

    // }
    // handleChange = (e) => {
    //     console.log(e);
    // }
    // handleSubmit = (e) => {
    //     console.log(e);
    // }
    render() {


        return (
            <section>

            <section className="container section">

            <h4 className="title center">Sketch</h4>
                        <div id="huaContent">
                            <div className="huaContent3">
                                <img src="../img30/3.jpg" alt=""   className="responsive-img materialboxed"></img>
                            </div>
                            <div className="huaContent1">
                                <img src="../img30/1.jpg" alt=""   className="responsive-img materialboxed"></img>
                            </div>
                            <div className="huaContent2">
                                <img src="../img30/2.jpg" alt=""   className="responsive-img materialboxed"></img>
                            </div>
                        </div>

        {/* <div className="row">
        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img30/4.jpg" alt="" className="responsive-img materialboxed"/>
            </div>
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img30/5.jpg" alt="" className="responsive-img materialboxed"/>
            </div>
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img30/6.jpg" alt="" className="responsive-img materialboxed"/>
            </div>
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img30/7.jpg" alt="" className="responsive-img materialboxed"/>
            </div>
            </div>
        </div>
        </div>

        <div className="row">
        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img30/8.jpg" alt="" className="responsive-img materialboxed"/>
            </div>
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img30/9.jpg" alt="" className="responsive-img materialboxed"/>
            </div>
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img30/10.jpg" alt="" className="responsive-img materialboxed"/>
            </div>
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img30/11.jpg" alt="" className="responsive-img materialboxed"/>
            </div>
            </div>
        </div>
        </div> */}
            
        </section>   
       
        </section>

        )
    }
}






export default hua